import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import TimeDisplay from './timeDisplay';
import ConfirmPopup from './confirmPopup';
import './styles.css';

class Service1260 extends Component {
  /**************
   * Properties *
   **************/
  bannerVisible = {
    visible: true
  };
  header = {
    id: 'header',
    src: require('./images/1260_elements.png')
  };
  navigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/main_menu'
  };
  arrows = {
    down: require('./images/ArrowDown.png'),
    up: require('./images/ArrowUp.png')
  };

  timeValues = [require('./images/Time_15.png'), require('./images/Time_30.png'), require('./images/Time_45.png')];

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1260">
        <Switch>
          <Route path="/sleep_timer/confirm/:current" render={routeProps => <ConfirmPopup {...routeProps} />} />
          <Route
            path="/sleep_timer/:current"
            render={routeProps => (
              <TimeDisplay
                {...routeProps}
                banner={this.bannerVisible}
                header={this.header}
                navigationBar={this.navigationBar}
                timeList={this.timeValues}
                arrows={this.arrows}
              />
            )}
          />
          <Route path="/sleep_timer" render={() => <Redirect to="/sleep_timer/2" />} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Service1260);
